// Centralized shape constants to ensure consistency across all components
export const SHAPE_OPTIONS = [
  {
    id: "sharp",
    name: "Sharp",
    description: "Clean, angular edges for a modern, professional look",
    borderRadius: "0px",
    buttonStyle: "square"
  },
  {
    id: "soft",
    name: "Soft",
    description: "Gentle, rounded corners for a friendly, approachable feel",
    borderRadius: "12px",
    buttonStyle: "rounded"
  },
  {
    id: "round",
    name: "Round",
    description: "Fully rounded elements for a playful, modern aesthetic",
    borderRadius: "32px",
    buttonStyle: "pill"
  }
]

// Helper function to find shape by border radius and button style
export const findShapeById = (shapeId) => SHAPE_OPTIONS.find((option) => option.id === shapeId)

// Helper function to find shape by border radius and button style
export const findShapeByValues = (borderRadius, buttonStyle) =>
  SHAPE_OPTIONS.find((option) => option.borderRadius === borderRadius && option.buttonStyle === buttonStyle)

// Default shape fallback
export const DEFAULT_SHAPE = SHAPE_OPTIONS[1] // "soft"
